import { DateField, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import moment from 'moment'
import React from 'react'

// Accepts either `date` (the documented prop) or a raw `value` some callers
// pass by mistake — both get normalized to a moment instance so a raw
// string/Date from the API never reaches AdapterMoment, which crashes
// calling .isValid() on anything that isn't a moment object.
const AnDateField = ({ date, value, ...props }) => {
  const raw = date ?? value

  return (
    <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="en-gb">
      <DateField
        desktopmodemediaquery="@media (min-width:0px)"
        autoComplete="off"
        name="date"
        {...props}
        value={raw ? moment(raw) : null}
      />
    </LocalizationProvider>
  )
}

export default AnDateField
